import React from 'react';
import { Box, Card, Chip, Container, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import StoreIcon from '@mui/icons-material/Store';

import visaLogo from '../../../../assets/visaLogo.png';
import masterLogo from '../../../../assets/masterLogo.png';
import amexLogo from '../../../../assets/amexLogo.png';
import itauLogo from '../../../../assets/itau-logo.png';
import moment from 'moment';

import interfisa from '../../../../assets/interfisa-bank.jpg';
import basa from '../../../../assets/banco-basa-bank.jpg';
import atlas from '../../../../assets/banco-atlas-bank.jpg';
import sudameris from '../../../../assets/sudameris-bank.jpg';
// import vision from '../../../../assets/vision-bank.jpg';
import gnb from '../../../../assets/gnb-bank.jpg';
import bancop from '../../../../assets/bancop-logo.png';
import continental from '../../../../assets/continental-bank.jpg';
import familiar from '../../../../assets/banco-familiar-logo.jpg';
import bancorio from '../../../../assets/bancorio-logo.png';
//import regional from '../../../../assets/regional-bank.jpg';

import {
	benefitRowSx,
	logoBoxSx,
	logoGridSx,
	paymentCardSx,
	paymentIntroSx,
	paymentMethodChipSx,
	paymentNoteSx,
	paymentSectionTitleSx,
} from './sharedStyles';

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		root: {
			flexGrow: 1,
			paddingTop: theme.spacing(2),
			maxWidth: '100%',
		},
		paymentMethodsGrid: {
			display: 'flex',
			flexWrap: 'wrap',
			gap: theme.spacing(1),
			marginTop: theme.spacing(1),
			marginBottom: theme.spacing(1),
		},
		paymentIcon: {
			marginRight: theme.spacing(0.5),
			color: theme.palette.secondary.main,
		},
		noUnderlineLinks: {
			textDecoration: 'none',
			color: 'inherit',
		},
		bankLogo: {
			maxWidth: '50px',
			flex: '0 0 auto',
		},
	}),
);

const banksPromotionData = [
	{
		bankName: 'Itaú',
		link: 'https://www.itau.com.py/Beneficios/Detalle/6062-agenciadeviajes',
		description: 'Hasta 10 y 12 cuotas sin interés según la tarjeta de crédito del Banco Itaú',
		promotionOn: '2025-02-08',
		// Vigencia extendida por indicación de Sebastian (2026-08-06).
		promotionDateOff: '2026-12-31',
		logo: itauLogo,
		preferred: '#EE7000',
	},
	{
		bankName: 'Basa',
		// Verificado 2026-08-06 contra las bases y condiciones oficiales (PDF del
		// link): Oro hasta 18, Black y Visa Signature hasta 24. "Todos los días
		// hasta el 31 de diciembre de 2026". No aplica a pagos web/link de pago.
		link: 'https://www.bancobasa.com.py/storage/app/media/modificacion%20cambio%20de%20la%20B/Basa_Alianzas_Bases-Y-Condiciones_Agencias%20de%20viajes.pdf',
		description:
			'Hasta 18 (Mastercard Oro) y 24 (Mastercard Black y Visa Signature) cuotas sin interés con tarjetas del Banco Basa \n PAGO PRESENCIAL',
		promotionOn: '2025-01-01',
		promotionDateOff: '2026-12-31',
		logo: basa,
	},
	{
		bankName: 'Bancop',
		link: 'https://www.bancop.com.py/public/6a14356adca81ddf831625f5c06ca972.pdf',
		description: 'Hasta 18  cuotas sin interés con tarjetas de crédito de Bancop',
		promotionOn: '2025-01-01',
		promotionDateOff: '2025-12-31',
		logo: bancop,
	},
	{
		bankName: 'Sudameris',
		// Verificado 2026-08-06 en la página oficial de la promo: "hasta 12
		// cuotas sin interés todos los días hasta el 31 de diciembre de 2026 con
		// todas tus tarjetas de crédito", incluye rubro Viajes y Hoteles.
		link: 'https://www.sudameris.com.py/beneficios/destacado/147/detalle',
		description: 'Hasta 12 cuotas sin interés con tarjetas de crédito del Banco Sudameris',
		promotionOn: '2026-01-01',
		promotionDateOff: '2026-12-31',
		logo: sudameris,
	},
	{
		bankName: 'Banco Río',
		link: 'https://www.rio.com.py/download/files/bases-y-condiciones-promo-viajes-agencias-de-viajes-y-aerolineas-2025_1738365309.pdf',
		description: 'Hasta 18 (Crédito Black) y 12 cuotas sin interés con tarjetas de crédito del Banco Río',
		promotionOn: '2025-01-01',
		promotionDateOff: '2025-12-31',
		logo: bancorio,
	},
	{
		bankName: 'Interfisa',
		// Verificado 2026-08-06 contra las BYC oficiales "Interfisa Viajes":
		// vigencia 25/07/2025 → 31/12/2026. Agencias: hasta 12 (Classic/Gold);
		// aerolíneas: hasta 18 (Platinum/Infinite/Black). No válido online.
		link: 'https://www.interfisa.com.py/storage/app/media/PDF%20PROMOCIONES/BYC%20INTEFISA%20VIAJES%202.pdf',
		description: 'Hasta 12 y 18 cuotas sin interés según la tarjeta de crédito del Banco Interfisa \n *PAGO PRESENCIAL',
		promotionOn: '2025-07-25',
		promotionDateOff: '2026-12-31',
		logo: interfisa,
	},
	{
		bankName: 'Atlas',
		link: 'https://www.bancoatlas.com.py/web/beneficios',
		description: 'Hasta 12 cuotas sin interés con tarjetas de crédito del Banco Atlas \n PAGO PRESENCIAL',
		promotionOn: '2025-01-01',
		promotionDateOff: '2025-12-31',
		logo: atlas,
	},

	// {
	// 	bankName: 'Vision',
	// 	link: 'https://www.visionbanco.com/archivos/Bases_y_condiciones_-_Agencias_y_Aerolineas_Nuevo_Formato_-_12.23.pdf',
	// 	description: 'Hasta 18 cuotas sin interés con tarjetas de crédito del Banco Vision',
	// 	promotionOn: '2023-01-02',
	// 	promotionDateOff: '2023-12-31',
	// },
	{
		bankName: 'GNB',
		// Verificado 2026-08-06 en la página oficial del beneficio: hasta 18
		// cuotas sin intereses en agencias de viajes y aerolíneas, vigencia
		// 05/01/2026 → 31/12/2026, no aplica comercio electrónico.
		link: 'https://www.beneficiosbancognb.com.py/beneficios/14/',
		description: 'Hasta 18 cuotas sin interés con tarjetas de crédito del Banco GNB \n PAGO PRESENCIAL',
		promotionOn: '2026-01-05',
		promotionDateOff: '2026-12-31',
		logo: gnb,
	},
	{
		bankName: 'Familiar',
		link: 'https://www.familiar.com.py/assets/media/info-util/promociones/CONSOLIDADO_GENERAL_ABRIL.pdf?uid=1745258945',
		description:
			'Hasta 24 (Platinum y Oro) y 12 (clásicas) cuotas sin interés con tarjetas de crédito del Banco Familiar \n PAGO PRESENCIAL',
		promotionOn: '2022-02-01',
		promotionDateOff: '2025-12-31',
		logo: familiar,
	},
	{
		bankName: 'Continental',
		link: 'https://www.bancontinental.com.py/#/club-continental/comercios',
		description: 'Hasta 12 cuotas sin interés con tarjetas de crédito del Banco Continental \n PAGO PRESENCIAL',
		promotionOn: '2022-01-01',
		promotionDateOff: '2025-12-31',
		logo: continental,
	},
	// {
	// 	bankName: 'Regional',
	// 	link: 'https://cdn.regional.com.py/media/uploaded-files/Beneficios/Cat%C3%A1logo%20CENTRAL%2027.04.pdf',
	// 	description: 'Hasta 12 cuotas sin interés con tarjetas de crédito del Banco Regional',
	// 	promotionOn: '2022-01-01',
	// 	promotionDateOff: '2022-08-31',
	// },
];

interface MevueloPYPaymentMethodsProps {
	isExternal?: boolean;
}

const MevueloPYPaymentMethods = ({ isExternal }: MevueloPYPaymentMethodsProps): JSX.Element => {
	const classes = useStyles();
	const currentDate = moment();

	const paymentMethods = [
		{
			label: 'Transferencia bancaria',
			icon: <AccountBalanceWalletIcon className={classes.paymentIcon} fontSize="small" />,
		},
		{
			label: 'Tarjetas de crédito y débito',
			icon: <CreditCardIcon className={classes.paymentIcon} fontSize="small" />,
		},
		{ label: 'Pago en el local', icon: <StoreIcon className={classes.paymentIcon} fontSize="small" /> },
		{ label: 'Redes de cobranza', icon: <AccountBalanceIcon className={classes.paymentIcon} fontSize="small" /> },
	];
	const cardLogos = [
		{ logo: visaLogo, alt: 'visa' },
		{ logo: amexLogo, alt: 'american-express' },
		{ logo: masterLogo, alt: 'master-card' },
	];

	const activePromotions = banksPromotionData.filter((item) =>
		currentDate.isBetween(
			moment(item.promotionOn, 'YYYY-MM-DD'),
			moment(item.promotionDateOff, 'YYYY-MM-DD'),
			'day',
			'[]',
		),
	);

	return (
		<div className={classes.root}>
			<Container component="main" maxWidth="md">
				<Typography component="h1" variant="h6" sx={paymentSectionTitleSx(isExternal)}>
					Nuestras formas de pago:
				</Typography>
				<Typography variant="body2" color="text.secondary" fontWeight={500} sx={paymentIntroSx}>
					Elegí la forma de pago que mejor se adapte a tu viaje. La cuotificación final puede depender del banco y la
					tarjeta.
				</Typography>
				<Card sx={paymentCardSx}>
					<Typography variant="body2" fontWeight={800} color="primary">
						Medios disponibles
					</Typography>
					<Box className={classes.paymentMethodsGrid}>
						{paymentMethods.map((method) => (
							<Chip key={method.label} icon={method.icon} label={method.label} size="small" sx={paymentMethodChipSx} />
						))}
					</Box>
					<Typography variant="body2" fontWeight={800} color="primary" mt={1.5}>
						Tarjetas
					</Typography>
					<Box sx={logoGridSx}>
						{cardLogos.map((card) => (
							<Box key={card.alt} sx={logoBoxSx}>
								<img src={card.logo} alt={card.alt} />
							</Box>
						))}
					</Box>
					{/* El label sólo aparece si hay promos VIGENTES: un título sin filas
					    abajo se lee como sección rota. Ojo: si todas las vigencias
					    (promotionDateOff) quedaron en el pasado, acá no se muestra nada —
					    eso es dato comercial a actualizar, no un bug de UI. */}
					{activePromotions.length > 0 && (
						<>
							<Typography variant="body2" fontWeight={800} color="primary" mt={2}>
								Aprovechá nuestros beneficios directos
							</Typography>
							{activePromotions.map((item) => (
								<a
									key={item.bankName}
									className={classes.noUnderlineLinks}
									href={item.link}
									target="_blank"
									rel="noreferrer"
								>
									<Box
										sx={{
											...benefitRowSx,
											...(item.preferred && {
												border: `2px solid ${item.preferred}`,
												paddingTop: '16px',
											}),
										}}
									>
										<img src={item.logo} alt={`${item.bankName} logo`} className={classes.bankLogo} />
										{/* Bold sólo para la promo recomendada (Itaú): las demás en peso
										    normal para que la jerarquía acompañe a la recomendación. */}
										<Typography
											variant="body2"
											align="right"
											fontWeight={item.preferred ? 700 : 400}
											color={item.preferred ? 'text.primary' : 'text.secondary'}
											sx={{ whiteSpace: 'pre-line', minWidth: 0 }}
										>
											{item.description}
										</Typography>
										{item.preferred && (
											<Box
												sx={{
													position: 'absolute',
													top: '-10px',
													right: '-6px',
													backgroundColor: item.preferred,
													color: 'white',
													borderRadius: '999px',
													fontWeight: 'bold',
													fontSize: '0.75rem',
													padding: '4px 10px',
													display: 'flex',
													alignItems: 'center',
													boxShadow: '0px 2px 6px rgba(0,0,0,0.2)',
												}}
											>
												<span style={{ marginRight: 4 }}>⭐</span> Recomendado
											</Box>
										)}
									</Box>
								</a>
							))}
						</>
					)}
					<Typography sx={paymentNoteSx} variant="body2" align="center" color="text.secondary" fontWeight={700}>
						Tarjetas de crédito de otros bancos en un solo pago sin interés o en cuotas con recargo. Consultá con tu
						banco.
					</Typography>
				</Card>
			</Container>
		</div>
	);
};

export default MevueloPYPaymentMethods;
